<template>
  <div>
    <div class="row justify-content-center mb-2">
      <button class="btn btn-add" id="v-step-0" @click="startTour">
        Iniciar Tour
      </button>
    </div>
    <div class="row justify-content-center" id="v-step-1"></div>
    <v-tour name="myTour" :steps="steps">
      <template slot-scope="tour">
        <transition name="fade">
          <v-step
            v-if="tour.currentStep === index"
            v-for="(step1, index) of tour.steps"
            :key="index"
            :step="step1"
            :previous-step="tour.previousStep"
            :next-step="tour.nextStep"
            :stop="tour.stop"
            :skip="tour.skip"
            :is-first="tour.isFirst"
            :is-last="tour.isLast"
            :labels="tour.labels"
          >
            <template>
              <div slot="actions">
                <button
                  v-if="tour.currentStep != 0"
                  @click="tour.previousStep"
                  class="btn-step-back"
                >
                  Anterior
                </button>
                <button
                  @click="cancelTour(tour.currentStep)"
                  class="btn-step-back"
                >
                  Pular tour
                </button>
                <button
                  @click="
                    nextTour(
                      tour.currentStep,
                      tour.steps[index + 1],
                      tour.steps[index]
                    )
                  "
                  v-if="tour.currentStep != 1"
                  class="btn-step"
                >
                  Próximo
                </button>
                <button
                  @click="cancelTour(tour.currentStep)"
                  v-else
                  class="btn-step"
                >
                  Finalizar
                </button>
              </div>
            </template>
          </v-step>
        </transition>
      </template>
    </v-tour>
    <base-crud
      crudName="Filiais"
      newText="Nova Filial"
      :table="table"
      :columns="columns"
      :options="options"
      :endPoint="endPoint"
      :enableAdd="true"
      :enableEdit="true"
      :enableDelete="true"
      :enableView="true"
      :dataForm="dataForm"
      @tvUrl="openTvModal"
      @tvConfig="openTvConfigModal"
      :extra="extra"
    >
    </base-crud>
    <tv-panel-config-modal ref="tvPanelConfigModal" />
    <b-modal id="modal-tv-url" title="Link público da TV (Filial)" hide-footer>
      <p class="text-muted">
        Abra esta URL em uma TV ou tablet para exibir a agenda de todas as
        salas desta filial em formato de carrossel. Não requer login.
        Qualquer pessoa com o link poderá visualizar os horários.
      </p>
      <div class="form-group">
        <input
          type="text"
          class="form-control"
          :value="tvUrl"
          readonly
          ref="tvUrlInput"
          @focus="$event.target.select()"
        />
      </div>
      <div class="text-right">
        <button class="btn btn-add" @click="copyTvUrl">
          <i class="fa fa-copy"></i>
          {{ tvCopied ? 'Copiado!' : 'Copiar' }}
        </button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import BaseCrud from "../Base/BaseCrud";
import TvPanelConfigModal from "./TvPanelConfigModal";

export default {
  data: function () {
    return {
      tvUrl: "",
      tvCopied: false,
      extra: [
        {
          id: 1,
          label: "",
          class: "btn btn-crud check",
          icon: "fas fa-tv",
          title: "Link da TV Geral",
          name: "tvUrl",
        },
        {
          id: 2,
          label: "",
          class: "btn btn-crud view",
          icon: "fas fa-cog",
          title: "Configurar painel TV",
          name: "tvConfig",
        },
      ],
      steps: [
        {
          target: "#v-step-0", // We're using document.querySelector() under the hood
          header: {
            title: "Tela de Filiais!",
          },
          params: {
            enableScrolling: false,
          },
          content: `Clique em <strong>próximo</strong> para continuar no tour. Caso não queira esse acompanhamento, clique em <strong>Pular tour</strong>. Se preferir poderá ver esse tour guiado a qualquer momento no botão destacado no menu superior.`,
        },
        {
          target: "#v-step-1",
          params: {
            enableScrolling: false,
          },
          content:
            "Em Filiais podemos criar novas filiais para a sua empresa clicando em Nova Filial, e também podemos editar uma filial já existente basta clicar em <i class='fas fa-pencil-alt'></i>, também podemos deletar uma filial de sua empresa basta clicar em <i class='fas fa-trash-alt'></i>.",
        },
      ],
      table: "branchTable",
      pages: [],
      url: "",
      columns: [
        "id",
        "title",
        "building_name",
        "company_id",
        "city",
        "state",
        "actions",
      ],
      tableData: [
        "id",
        "title",
        "building_name",
        "company_id",
        "city",
        "state",
      ],
      options: {
        filterByColumn: true,
        debounce: 1000,
        filterable: ["title", "building_name", "company_id", "city", "state"],
        pagination: { chunk: 10, dropdown: false, nav: "scroll" },
        perPage: 10,
        perPageValues: [10, 25, 50, 100],
        headings: {
          id: "ID",
          title: "Título",
          building_name: "Prédio",
          company_id: "Empresa",
          city: "Cidade",
          state: "UF",
          actions: "Ações",
        },
        templates: {
          company_id: function (h, row, index) {
            return row.company ? row.company.company_name : "Sem Nome";
          },
        },
        texts: {
          filterBy: "Filtrar",
          defaultOption: "Selecione",
        },
        requestFunction: function (data) {
          let requestData = {};

          let query = this.$parent.$parent.query(data.query);
          requestData.params = data;
          requestData.params.query = "";
          requestData.params.with = ["company"];

          return this.$http.get(this.url + "?" + query, requestData).catch(
            function (e) {
              this.dispatch("error", e);
            }.bind(this)
          );
        },
      },
      endPoint: "branches/",
      dataForm: {},
    };
  },
  components: {
    BaseCrud,
    TvPanelConfigModal,
  },
  methods: {
    cancelTour(step) {
      const self = this;
      self.$tours["myTour"].skip();
      self.$store.commit("skipTour");

      let data = { finished_step: step };

      const api = self.$store.state.api + "user/finish-tour";

      self.$http.post(api, data).then((response) => {});
    },
    nextTour(step, actual_target, previous_target) {
      const self = this;

      if (step >= 31) {
        if (step >= 31) {
          $(previous_target.target).toggleClass("activeMenu");
        }
        $(actual_target.target).toggleClass("activeMenu");
      }

      if (step == 1) {
        $("#sidebar").toggleClass("active");
        setTimeout(function () {
          self.$tours["myTour"].nextStep();
        }, 500);
      } else if (step == 31) {
        $("#pagCads").toggleClass("active");
        setTimeout(function () {
          self.$tours["myTour"].nextStep();
        }, 500);
      } else if (step == 31) {
        $("#sidebar").toggleClass("active");
        $("html, body").animate({ scrollTop: 0 }, 0);
        self.$tours["myTour"].nextStep();
      } else {
        self.$tours["myTour"].nextStep();
      }
    },
    startTour() {
      let self = this;
      self.$tours["myTour"].start();
    },
    query: function (query) {
      let columns = {
        id: "id",
        title: "title",
        building_name: "building_name",
        company_id: "company[company_name]",
        city: "city",
        state: "state",
      };
      let filters = "";
      $.each(query, function (index, value) {
        filters += columns[index] + "=" + value + "&";
      });
      return filters;
    },
    openTvConfigModal(row) {
      const id = row.row.id;
      const title = row.row.title || "";
      this.$refs.tvPanelConfigModal.open(id, title);
    },
    openTvModal(row) {
      const self = this;
      const id = row.row.id;
      const api = self.$store.state.api + "branches/" + id + "/tv-url";

      self.$http
        .get(api)
        .then((response) => {
          self.tvUrl = response.data.url;
          self.tvCopied = false;
          self.$bvModal.show("modal-tv-url");
        })
        .catch(() => {
          self.$message(null, "Não foi possível gerar o link da TV", "error");
        });
    },
    copyTvUrl() {
      const self = this;
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(self.tvUrl).then(() => {
          self.tvCopied = true;
          setTimeout(() => { self.tvCopied = false; }, 2000);
        });
      } else if (self.$refs.tvUrlInput) {
        self.$refs.tvUrlInput.select();
        document.execCommand("copy");
        self.tvCopied = true;
        setTimeout(() => { self.tvCopied = false; }, 2000);
      }
    },
  },
};
</script>

<style scoped>
.VuePagination {
  text-align: center;
}
</style>


// WEBPACK FOOTER //
// src/components/Branch/Crud.vue